module.exports = __webpack_public_path__ + "1a3f0e6c69c21bcdf533ebb2f0b42241.svg";